"use client";
// import { createCache, extractStyle, StyleProvider } from "@ant-design/cssinjs";
import {
  SessionProvider as NextSessionProvider,
  signOut,
  useSession,
} from "next-auth/react";
import { usePathname } from "next/navigation";
import { useEffect, useLayoutEffect, useState } from "react";

const PUBLIC_PATHNAME_PREFIXES = ["/login"];

const SessionUpdater = (session) => {
  const { update, status } = useSession();
  const pathname = usePathname();
  useEffect(() => {
    update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (status === "unauthenticated") {
      let is_public_page = false;
      PUBLIC_PATHNAME_PREFIXES.forEach(function (element) {
        // Check if the first word is prefix
        if (pathname.indexOf(element) == 0) {
          is_public_page = true;
        }
      });
      if (!is_public_page) {
        signOut({ callbackUrl: "/login?sex" });
      }
    }
  }, [pathname, session, status]);

  return <></>;
};

export const SessionProvider = ({ children, session }) => {
  // console.log(other);
  // const session = await auth()
  // if (session?.user) {
  //     session.user = {
  //       name: session.user.username,
  //       email: session.user.email,
  //       isAdmin: session.user.isAdmin,
  //     }
  //   }

  // return <ThemeProvider attribute="class">{children}</ThemeProvider>;
  return (
    <NextSessionProvider refetchInterval={60 * 1} session={session}>
      <SessionUpdater session={session} />
      {children}
    </NextSessionProvider>
  );
};
